import './style.scss'
import React from 'react'

export interface ToolbarProps {
    left?: React.ReactNode
    right?: React.ReactNode

    className?: string

    sticky?: boolean
}

export const Toolbar: React.FC<ToolbarProps> = ({
                                                    left,
                                                    right,
                                                    className = '',
                                                    sticky = false,
                                                }) => {

    return (

        <div
            className={`toolbar ${
                sticky ? 'toolbar--sticky' : ''
            } ${className}`}
        >

            <div className="toolbar__left">
                {left}
            </div>

            <div className="toolbar__right">
                {right}
            </div>

        </div>

    )

}

export default Toolbar